import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.pos.customer');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type CartItem = { menuId: number; name: string; desc: string; price: number; qty: number };

@Component({
    selector: 'wiz-page-pos-customer',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.pos.customer/view.scss */
:host {
  display: block;
  min-height: 100%;
}

* {
  box-sizing: border-box;
}

.customer-page {
  min-height: 100vh;
  background: #f5f7fb;
  color: #172033;
  font-family: "Noto Sans KR", -apple-system, BlinkMacSystemFont, sans-serif;
}

.customer-header {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 22px;
  background: #ffffff;
  border-bottom: 1px solid #dde3ed;
}

.brand-block {
  min-width: 0;
}
.brand-block h1 {
  margin: 2px 0 4px;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 800;
}
.brand-block p {
  margin: 0;
  color: #667085;
  font-size: 13px;
  line-height: 1.45;
}

.brand-kicker,
.cart-kicker {
  display: block;
  color: #2f6fed;
  font-size: 12px;
  font-weight: 800;
}

.order-badge {
  flex-shrink: 0;
  min-width: 82px;
  height: 34px;
  border-radius: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #e8f7ef;
  color: #087443;
  font-size: 13px;
  font-weight: 800;
}
.order-badge.closed {
  background: #fff3e0;
  color: #b54708;
}

.message-bar {
  margin: 12px auto 0;
  width: calc(100% - 32px);
  max-width: 1180px;
  padding: 11px 14px;
  border-radius: 8px;
  background: #edf4ff;
  border: 1px solid #c7dcff;
  color: #1d4ed8;
  font-size: 14px;
  font-weight: 700;
}
.message-bar.success {
  background: #ecfdf3;
  border-color: #b7ebc6;
  color: #087443;
}
.message-bar.error {
  background: #fff1f0;
  border-color: #ffc9c3;
  color: #c33124;
}

.loading-state {
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  color: #667085;
  font-weight: 700;
}

.spinner {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 4px solid #dbe4f0;
  border-top-color: #2f6fed;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.customer-main {
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
  padding: 16px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 16px;
  align-items: start;
}

.menu-panel,
.cart-panel {
  background: #ffffff;
  border: 1px solid #dde3ed;
  border-radius: 8px;
}

.menu-panel {
  min-width: 0;
  overflow: hidden;
}

.closed-notice {
  display: grid;
  gap: 4px;
  margin: 14px;
  padding: 14px;
  border-radius: 8px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #9a3412;
}
.closed-notice strong {
  font-size: 14px;
}
.closed-notice span {
  font-size: 13px;
}

.category-tabs {
  display: flex;
  gap: 8px;
  padding: 14px;
  overflow-x: auto;
  border-bottom: 1px solid #dde3ed;
}

.cat-tab {
  flex-shrink: 0;
  min-height: 38px;
  padding: 0 16px;
  border-radius: 20px;
  border: 1px solid #d0d8e5;
  background: #f8fafc;
  color: #475467;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
}
.cat-tab.active {
  background: #2f6fed;
  border-color: #2f6fed;
  color: #fff;
}

.menu-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  padding: 14px;
}

.menu-card {
  min-height: 116px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
  text-align: left;
  padding: 14px;
  border-radius: 8px;
  border: 1px solid #d8e0eb;
  background: #ffffff;
  color: #172033;
  cursor: pointer;
}
.menu-card:active:not(:disabled) {
  transform: scale(0.98);
}
.menu-card.soldout {
  opacity: 0.55;
  cursor: not-allowed;
  background: #f3f4f6;
}

.menu-info {
  display: grid;
  gap: 4px;
}

.menu-name {
  font-size: 16px;
  font-weight: 900;
  line-height: 1.25;
}

.menu-desc {
  color: #667085;
  font-size: 13px;
}

.menu-price-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.menu-price {
  font-size: 15px;
  font-weight: 900;
  color: #0f766e;
}

.add-mark,
.soldout-label {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
}

.add-mark {
  background: #edf4ff;
  color: #2f6fed;
  font-size: 20px;
}

.soldout-label {
  width: auto;
  padding: 0 8px;
  border-radius: 6px;
  background: #fee4e2;
  color: #b42318;
  font-size: 12px;
}

.cart-panel {
  position: sticky;
  top: 84px;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 100px);
  overflow: hidden;
}

.cart-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 16px;
  border-bottom: 1px solid #dde3ed;
}
.cart-head h2 {
  margin: 2px 0 0;
  font-size: 20px;
  font-weight: 900;
}

.cart-count {
  min-width: 44px;
  text-align: center;
  padding: 6px 10px;
  border-radius: 16px;
  background: #f1f5f9;
  color: #475467;
  font-size: 13px;
  font-weight: 900;
}

.order-fields {
  display: grid;
  gap: 9px;
  padding: 14px 16px;
  border-bottom: 1px solid #dde3ed;
}

.field {
  display: grid;
  gap: 5px;
}
.field span {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}
.field input,
.field select {
  width: 100%;
  height: 38px;
  border: 1px solid #cfd8e6;
  border-radius: 6px;
  padding: 0 10px;
  background: #ffffff;
  color: #172033;
  font-size: 14px;
  outline: none;
}
.field input:focus,
.field select:focus {
  border-color: #2f6fed;
  box-shadow: 0 0 0 3px rgba(47, 111, 237, 0.14);
}

.cart-list {
  flex: 1;
  min-height: 120px;
  overflow: auto;
  padding: 8px 16px;
}

.cart-empty {
  min-height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #98a2b3;
  font-size: 14px;
  font-weight: 700;
}

.cart-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
  padding: 11px 0;
  border-bottom: 1px solid #edf1f6;
}

.ci-main {
  min-width: 0;
  display: grid;
  gap: 3px;
}
.ci-main strong {
  color: #172033;
  font-size: 14px;
}

.ci-name {
  font-size: 14px;
  font-weight: 900;
}

.ci-desc {
  color: #667085;
  font-size: 12px;
}

.qty-control {
  display: grid;
  grid-template-columns: 32px 34px 32px;
  align-items: center;
  height: 34px;
  border: 1px solid #d8e0eb;
  border-radius: 18px;
  overflow: hidden;
}
.qty-control button {
  height: 100%;
  border: 0;
  background: #f8fafc;
  color: #172033;
  font-size: 18px;
  font-weight: 900;
  cursor: pointer;
}
.qty-control span {
  text-align: center;
  font-size: 14px;
  font-weight: 900;
}

.cart-total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-top: 1px solid #dde3ed;
  font-size: 15px;
  font-weight: 900;
}
.cart-total strong {
  font-size: 22px;
  color: #2f6fed;
}

.cart-actions {
  display: grid;
  grid-template-columns: 96px 1fr;
  gap: 8px;
  padding: 0 16px 16px;
}
.cart-actions button {
  height: 46px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 900;
  cursor: pointer;
}
.cart-actions button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.clear-btn {
  border: 1px solid #d0d8e5;
  background: #ffffff;
  color: #475467;
}

.submit-btn {
  border: 0;
  background: #2f6fed;
  color: #fff;
}

.order-status {
  display: grid;
  gap: 8px;
  margin: 0 16px 16px;
  padding: 12px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #dde3ed;
}

.status-top,
.payment-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.status-pill {
  padding: 5px 10px;
  border-radius: 14px;
  background: #edf4ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 900;
}
.status-pill.error {
  background: #fff1f0;
  color: #c33124;
}
.status-pill.done {
  background: #ecfdf3;
  color: #087443;
}
.status-pill.cancel {
  background: #f2f4f7;
  color: #667085;
}

.status-id {
  color: #667085;
  font-size: 12px;
  word-break: break-all;
}

.status-amount {
  font-size: 18px;
  font-weight: 900;
}

.refresh-btn,
.cancel-btn,
.payment-row button {
  min-height: 32px;
  border-radius: 6px;
  border: 1px solid #d0d8e5;
  background: #ffffff;
  color: #475467;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
}

.payment-row select {
  flex: 1;
  height: 34px;
  border: 1px solid #cfd8e6;
  border-radius: 6px;
  background: #fff;
  padding: 0 8px;
}
.payment-row button {
  padding: 0 10px;
  background: #0f766e;
  color: #fff;
  border-color: #0f766e;
}

.cancel-btn {
  color: #b42318;
}
.cancel-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .customer-main {
    grid-template-columns: 1fr;
  }
  .cart-panel {
    position: static;
    max-height: none;
  }
  .menu-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 540px) {
  .customer-header {
    align-items: flex-start;
    padding: 14px 16px;
  }
  .brand-block h1 {
    font-size: 20px;
  }
  .customer-main {
    padding: 10px;
  }
  .menu-grid {
    grid-template-columns: 1fr;
    padding: 10px;
  }
  .cart-actions {
    grid-template-columns: 1fr;
  }
}`],
})
export class PagePosCustomerComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) {}

    public store: any = { name: 'POS' };
    public categories: any[] = [];
    public menus: any[] = [];
    public tables: any[] = [];
    public activeCategory = '';
    public cart: CartItem[] = [];
    public tableId = '';
    public customerName = '';
    public phone = '';
    public memo = '';
    public businessOpen = false;
    public loading = true;
    public submitting = false;
    public message = '';
    public messageType: 'info' | 'success' | 'error' = 'info';
    public order: any = null;
    public paymentMethod = 'counter';

    get availableMenus() {
        const category = this.activeCategory;
        return this.menus.filter(menu => !category || menu.category === category);
    }

    get cartCount() {
        return this.cart.reduce((sum, item) => sum + item.qty, 0);
    }

    get cartTotal() {
        return this.cart.reduce((sum, item) => sum + item.price * item.qty, 0);
    }

    get canSubmit() {
        return this.businessOpen && !this.submitting && !!this.tableId && this.cart.length > 0;
    }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load() {
        this.loading = true;
        this.message = '';
        let res = await wiz.call('public_bootstrap');
        if (res.code === 200) {
            const data = res.data.data || {};
            this.store = data.store || this.store;
            this.categories = data.categories || [];
            this.menus = data.menus || [];
            this.tables = data.tables || [];
            this.businessOpen = !!data.businessOpen;
            this.activeCategory = this.categories.length ? this.categories[0].id : '';
        } else {
            this.setMessage(res.data?.message || '메뉴를 불러오지 못했습니다.', 'error');
        }
        this.loading = false;
    }

    public selectCategory(categoryId: string) {
        this.activeCategory = categoryId;
    }

    public addMenu(menu: any) {
        if (menu.isSoldOut) return;
        const found = this.cart.find(item => item.menuId === menu.id);
        if (found) {
            found.qty += 1;
        } else {
            this.cart.push({
                menuId: menu.id,
                name: menu.name,
                desc: menu.desc || '',
                price: Number(menu.price) || 0,
                qty: 1,
            });
        }
        this.setMessage(`${menu.name} 추가됨`, 'success');
    }

    public changeQty(item: CartItem, delta: number) {
        const nextQty = item.qty + delta;
        if (nextQty <= 0) {
            this.cart = this.cart.filter(row => row.menuId !== item.menuId);
            return;
        }
        item.qty = Math.min(99, nextQty);
    }

    public clearCart() {
        this.cart = [];
        this.setMessage('장바구니를 비웠습니다.', 'info');
    }

    public async submitOrder() {
        if (!this.canSubmit) return;
        this.submitting = true;
        this.message = '';
        const payload = this.cart.map(item => ({ menuId: item.menuId, qty: item.qty }));
        let res = await wiz.call('submit_order', {
            tableId: Number(this.tableId),
            customerName: this.customerName,
            phone: this.phone,
            memo: this.memo,
            items: JSON.stringify(payload),
        });
        this.submitting = false;
        if (res.code === 200) {
            this.order = res.data.data;
            this.cart = [];
            this.setMessage('주문이 접수되었습니다. 직원 확인 후 조리가 진행됩니다.', 'success');
        } else {
            this.setMessage(res.data?.message || '주문 접수 중 오류가 발생했습니다.', 'error');
        }
    }

    public async cancelOrder() {
        if (!this.order?.orderId) return;
        let res = await wiz.call('cancel_order', { orderId: this.order.orderId, reason: '고객 화면 취소' });
        if (res.code === 200) {
            this.order.status = 'canceled';
            this.setMessage('주문 요청이 취소되었습니다.', 'success');
        } else {
            this.setMessage(res.data?.message || '취소할 수 없습니다. 직원을 호출해주세요.', 'error');
        }
    }

    public async requestPayment() {
        if (!this.order?.orderId) return;
        let res = await wiz.call('request_payment', { orderId: this.order.orderId, method: this.paymentMethod });
        if (res.code === 200) {
            this.order.status = res.data.status || 'payment_requested';
            this.setMessage('결제 요청이 전달되었습니다.', 'success');
        } else {
            this.setMessage(res.data?.message || '결제 요청을 처리하지 못했습니다.', 'error');
        }
    }

    public async refreshStatus() {
        if (!this.order?.orderId) return;
        let res = await wiz.call('order_status', { orderId: this.order.orderId });
        if (res.code === 200) {
            this.order = res.data.data;
            this.setMessage('주문 상태를 갱신했습니다.', 'info');
        }
    }

    public statusLabel(status: string) {
        const labels: any = {
            submitted: '주문 접수',
            payment_requested: '결제 요청',
            payment_failed: '결제 오류',
            canceled: '취소됨',
            error: '오류',
            paid: '결제 완료',
        };
        return labels[status] || status || '-';
    }

    public formatCurrency(value: number) {
        return (Number(value) || 0).toLocaleString();
    }

    private setMessage(text: string, type: 'info' | 'success' | 'error') {
        this.message = text;
        this.messageType = type;
    }
}

export default PagePosCustomerComponent;